import { StyleSheet } from 'react-native';

/** 默认配置 */
export const TITLE_PAIR_DEFAULTS = {
    titleFontSize: 16,
    titleColor: '#333333',
    titleFontWeight: '600' as const,
    subtitleFontSize: 13,
    subtitleColor: '#999999',
    subtitleFontWeight: '400' as const,
    gap: 4,
};

/** 创建样式 */
export const createStyles = () => {
    return StyleSheet.create({
        // 容器 - 水平布局
        containerHorizontal: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        // 容器 - 垂直布局
        containerVertical: {
            flexDirection: 'column',
        },
        // 容器 - 两端对齐布局
        containerSpaceBetween: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        // 容器 - 翻转
        containerReverse: {
            flexDirection: 'row-reverse',
        },
        containerVerticalReverse: {
            flexDirection: 'column-reverse',
        },
        // 内容区域
        contentContainer: {
            flex: 1,
        },
        // 内容区域 - 两端对齐时不需要 flex: 1
        contentContainerSpaceBetween: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            flex: 1,
        },
        contentContainerHorizontal: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        contentContainerVertical: {
            flexDirection: 'column',
        },
        // 对齐方式
        alignLeft: {
            alignItems: 'flex-start',
        },
        alignCenter: {
            alignItems: 'center',
        },
        alignRight: {
            alignItems: 'flex-end',
        },
        // 垂直对齐（水平布局时）
        verticalAlignTop: {
            alignItems: 'flex-start',
        },
        verticalAlignCenter: {
            alignItems: 'center',
        },
        verticalAlignBottom: {
            alignItems: 'flex-end',
        },
        // 主标题
        title: {
            fontSize: TITLE_PAIR_DEFAULTS.titleFontSize,
            color: TITLE_PAIR_DEFAULTS.titleColor,
            fontWeight: TITLE_PAIR_DEFAULTS.titleFontWeight,
        },
        // 副标题
        subtitle: {
            fontSize: TITLE_PAIR_DEFAULTS.subtitleFontSize,
            color: TITLE_PAIR_DEFAULTS.subtitleColor,
            fontWeight: TITLE_PAIR_DEFAULTS.subtitleFontWeight,
        },
        // 必填星号
        required: {
            color: '#FF3B30',
            fontSize: 14,
            marginRight: 2,
        },
        requiredEnd: {
            marginLeft: 2,
            marginRight: 0,
        },
        // 左侧额外元素
        leftExtra: {
            marginRight: 8,
        },
        // 右侧额外元素
        rightExtra: {
            marginLeft: 8,
        },
        // 分割线
        divider: {
            height: StyleSheet.hairlineWidth,
            backgroundColor: '#EBEDF0',
            marginTop: 12,
        },
        // 可点击容器
        pressable: {
            // 保持容器样式
        },
    });
};
